import React from "react";

export default function SQL_LIMIT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_LIMIT</h1>
      <p>This is the SQL_LIMIT component generated from the SQL JSON.</p>
    </div>
  );
}
